/*
 * @Descripttion:
 * @Author: Jun Chen
 * @Date: 2021-1-22 23:07:49
 */
export default [
  {
    path: '/gift',
    name: 'gift',
    hidden: false,
    meta: {
      title: '送礼数据',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/giftIndex',
        name: 'giftIndex',
        hidden: false,
        meta: {
          title: '送礼数据',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/gift/manage'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-gift.js